import { DeleteButton } from "@/components/DeleteButton";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRemoveProjectLimitMutation } from "./hooks/useRemoveProjectLimitMutation";

interface ProjectLimitRemoveButtonProps {
  limitId: string;
  className?: string;
}

export const ProjectLimitRemoveButton = ({
  limitId,
  className,
}: ProjectLimitRemoveButtonProps) => {
  const { t } = useTranslation();
  const removeMutation = useRemoveProjectLimitMutation();
  const { formState } = useFormContext();

  const onRemove = useCallback(() => {
    removeMutation.mutateAsync(limitId);
  }, [limitId, removeMutation]);

  return (
    <DeleteButton
      variant="ghost"
      onClick={onRemove}
      label={t("projectLimits.removeRow")}
      className={className}
      disabled={formState.disabled || removeMutation.isPending}
    />
  );
};
